<template>
  <div>
    <div class="ui grid" v-if="!activeLicense">
      <div class="row">
        <sui-message class="red tiny">
          <sui-message-header>License expired</sui-message-header>
          <p class="content">
            You currently do not have an active license. Please get
            <a href="https://cooperation.ie/contact" target="_blank"
              >in touch</a
            >
            to ensure continued access.
          </p>
        </sui-message>
      </div>
    </div>
    <div class="ui grid" v-if="expiring">
      <div class="row">
        <sui-message class="red tiny">
          <sui-message-header>License expiring</sui-message-header>
          <p class="content">
            Your current license has expired on
            {{ activeLicense.endDate | moment('DD-MM-YYYY') }}. Please get
            <a href="https://cooperation.ie/contact" target="_blank"
              >in touch</a
            >
            to ensure continued access.
          </p>
        </sui-message>
      </div>
    </div>
    <div class="ui grid" v-if="!expiring && expiringWarning">
      <div class="row">
        <sui-message class="orange tiny">
          <sui-message-header>License expiring soon</sui-message-header>
          <p class="content">
            Your current license is expiring soon on
            {{ activeLicense.endDate | moment('DD-MM-YYYY') }}. Please get
            <a href="https://cooperation.ie/contact" target="_blank"
              >in touch</a
            >
            to ensure continued access.
          </p>
        </sui-message>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'ActiveLicense',
  components: {},
  computed: {
    ...mapGetters({
      activeLicense: 'activeLicense',
    }),
    expiring: {
      get() {
        if (this.activeLicense === null) return false;
        if (this.activeLicense.length === 0) return false;
        return moment(this.activeLicense.endDate) <= moment();
      },
    },
    expiringWarning: {
      get() {
        if (this.activeLicense === null) return false;
        if (this.activeLicense.length === 0) return false;
        return moment(this.activeLicense.endDate) <= moment().add(1, 'M');
      },
    },
  },
  created() {
    this.$store.dispatch('getActiveLicense');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/license/ActiveLicense.vue